import {
    getCusMsgTemplateConfig,
    getUserTicketInfoList,
    getTemplateFieldsInfo,
    getUserDealTicketInfoList,
    getTicketTypeInfoList,
    postMsg,
    isMessage,
    postMsgAfterVerify,
    addTicketSatisfactionScoreInfo,
    invokeOtherByUser,
    saveUserReplyInfo,
    checkVerificationCode,
    sendVerificationCode,
    sendVerificationCodeBySms,
    checkTicketValidateStatus,
    checkSmsVerificationCode,
    getTicketStatusInfoList
} from '../services/leaveMsg'
import strEscape from '../utils/strEscape'
import { ids, getIdsObj } from './app'

export default {
    namespace: 'leaveMsg',
    state: {
        isEvalution: 0,
        isUpload: false,
        isMsgFlag: 0, //是否留言
        isMsgStr: {},
        ticketId: '',
        leaveMsgInfo: {},
        currentItem: 1, //tab展示类型 1请您留言,2留言记录,3留言详情,4单独一个留言记录
        originField: [],
        templateFieldsInfo: [],
        extendFields: {},
        ticketTypeList: [],
        leaveMsgList: [],
        ticketStatusMap: [],
        messageDetail: [],
        zoomImgDisplay: 0, //是否预览图片
        zoomImgSrc: '', //预览的图片地址
        iseVrified: 0,
        initInfo: {},
        scoreData: [],
        solvedData: -1,
        star: '',
        tag: [],
        tagName: [],
        text: '',
        result: {}
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        },
        changeItem(state, { payload }) {
            return {
                ...state,
                currentItem: payload
            }
        },
        changeFieldsValue(state, { payload }) {
            return {
                ...state,
                extendFields: Object.assign(state.extendFields, payload)
            }
        },
        changeTicketList(state, { payload }) {
            return {
                ...state,
                ticketTypeList: payload
            }
        }
    },
    effects: {
        *getCusMsgTemplate({ payload, callback }, { call, put }) {
            const config = yield call(getCusMsgTemplateConfig, {
                param: JSON.stringify({
                    templateId: payload.templateid
                }),
                uid: payload.uid
            })
            if (config.retCode === '000000') {
                const {
                    templateId,
                    ticketTypeFlag,
                    msgTmp,
                    emailFlag,
                    emailShowFlag,
                    telFlag,
                    telShowFlag,
                    enclosureFlag,
                    enclosureShowFlag
                } = config.item
                //调用分类查询
                if (ticketTypeFlag === 1) {
                    const ticketTypeList = yield call(getTicketTypeInfoList, {
                        uid: payload.uid
                    })
                    yield put({
                        type: 'update',
                        payload: { ticketTypeList: ticketTypeList.data.items }
                    })
                }
                const fields = yield call(getTemplateFieldsInfo, {
                    param: JSON.stringify({
                        operateType: 3,
                        openFlag: 1,
                        templateId: templateId
                    }),
                    uid: payload.uid
                })
                const items = fields.data.items
                let extendFields = {}
                if (fields.status === 200 && fields.data.retCode === '000000') {
                    const originField = [
                        {
                            cusFieldConfig: {
                                fieldId: 'ticketContent',
                                fieldType: 3,
                                fillFlag: 1,
                                showField: 1,
                                fieldName: '问题描述',
                                operateType: 'origin',
                                placeholder: msgTmp.replace(
                                    /<[^>]+>|&#39;|&nbsp;|&amp;|&lt;|&gt;|&quot;/g,
                                    ''
                                )
                            }
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'file',
                                fieldType: 4,
                                fieldName: '附件',
                                fillFlag: enclosureFlag,
                                showField: enclosureShowFlag,
                                operateType: 'origin'
                            }
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'customerEmail',
                                fieldType: 1,
                                fieldName: '邮箱',
                                fillFlag: emailFlag,
                                showField: emailShowFlag,
                                operateType: 'origin'
                            }
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'customerPhone',
                                fieldType: 3,
                                fieldName: '手机',
                                fillFlag: telFlag,
                                showField: telShowFlag,
                                operateType: 'origin'
                            }
                        }
                    ]
                    items.forEach((obj) => {
                        const { fieldId } = obj.cusFieldConfig
                        extendFields[fieldId] = ''
                    })
                    yield put({
                        type: 'update',
                        payload: {
                            leaveMsgInfo: config.item,
                            templateFieldsInfo: items,
                            originField,
                            extendFields
                        }
                    })
                    callback()
                }
            }
        },
        *getMsgRecordList({ payload }, { call, put, select }) {
            // console.log(payload)
            // console.log(getUserTicketInfoList)
            const { queryParams } = yield select(({ app }) => app)

            const data = yield call(getUserTicketInfoList, {
                ...payload,
                partnerId: window.urlObject.partnerid || '',
                sysNum: window.urlObject.sysNum || '',
                ...getIdsObj(queryParams, ids)
            })
            // console.log(data)
            if (data?.retCode === '000000') {
                yield put({
                    type: 'update',
                    payload: {
                        leaveMsgList: data.items,
                        iseVrified: data.item
                    }
                })
            } else {
            }
        },
        *addLeaveMsg({ payload, callback }, { call, put }) {
            let data = {}
            if (payload.msgFlag) {
                data = yield call(postMsgAfterVerify, {
                    ...payload
                })
            } else {
                data = yield call(postMsg, {
                    ...payload,
                    partnerId: window.urlObject.partnerid || '',
                    sysNum: window.urlObject.sysNum || '',
                    deployId: window?.urlObject?.deployId || ''
                })
            }
            if (data.retCode === '000000') {
                callback()
            } else {
            }
        },
        *getLeaveMsgDetail({ payload }, { call, put }) {
            const data = yield call(getUserDealTicketInfoList, {
                uid: payload.uid,
                param: JSON.stringify({
                    ...payload.param,
                    deployId: window.urlObject.deployId || ''
                })
            })
            if (data.retCode === '000000') {
                const arr = data.items
                let msgDetail = []
                arr.forEach((obj) => {
                    if (obj.replayList) {
                        obj.replayList.forEach((o) => {
                            msgDetail.push({
                                content: o.replyContent,
                                flag: obj.flag,
                                isOpen: obj.flag,
                                time: o.replyTime,
                                timeStr: o.replyTimeStr,
                                startType: o.startType,
                                fileList: o.fileList,
                                ticketStatus: obj.ticketStatus,
                                replyStatus: o.acceptStatus
                            })
                        })
                    } else {
                        msgDetail.push({
                            ...obj,
                            replyStatus: obj.ticketStatus
                        })
                    }
                })
                // console.log('data.items[0].txtFlag----',data.items[0].txtFlag);
                let initData = {
                    initInfo: data?.items[0]?.cusNewSatisfactionVO
                        ? data?.items[0]?.cusNewSatisfactionVO
                        : {}
                }
                let {
                    defaultQuestionFlag,
                    scoreFlag,
                    defaultType,
                    scoreInfo = []
                } = data?.items[0].cusNewSatisfactionVO || {}
                // 初始化是否已解决
                if (defaultQuestionFlag) {
                    if (defaultQuestionFlag !== 2) {
                        initData.solvedData = defaultQuestionFlag
                    } else {
                        initData.solvedData = -1
                    }
                }
                // 初始化默认星级
                if (!data?.items?.[0]?.isEvalution) {
                    if (scoreFlag === 0 && defaultType === 0) {
                        let arr = scoreInfo.map((i) => {
                            let obj = {}
                            obj.checked = true
                            return { ...i, ...obj }
                        })
                        arr[0] = arr[arr.length - 1]
                        initData.scoreData = arr
                        initData.star = 5
                    } else {
                        let brr = scoreInfo.map((i) => {
                            let obj = {}
                            obj.checked = false
                            return { ...i, ...obj }
                        })
                        initData.scoreData = brr
                        initData.star = ''
                    }
                } else {
                    let crr = scoreInfo
                    crr[0] = crr[data?.items?.[0]?.score - 1]
                    initData.scoreData = crr
                    initData.star = ''
                }
                yield put({
                    type: 'update',
                    payload: {
                        currentItem: 3,
                        messageDetail: msgDetail,
                        isEvalution: data?.items?.[0]?.isEvalution || 0,
                        ticketId: payload.param.ticketId,
                        result: data.items[0],
                        ...initData
                    }
                })
                yield put({
                    type: 'app/changeItem',
                    payload: payload.param.showType
                })
            }
        },
        *getMessageInfo({ payload }, { call, put }) {
            const data = yield call(isMessage, {
                uid: payload.uid,
                msgFlag: 1 //h5
            })

            yield put({
                type: 'update',
                payload: {
                    isMsgFlag: data.isMessage,
                    isMsgStr: data.resStr && JSON.parse(data.resStr)
                }
            })
        },
        *commentService({ payload, callback }, { call, put, select }) {
            const { uid } = window.urlObject
            const { leaveMsg } = yield select()
            const data = yield call(addTicketSatisfactionScoreInfo, {
                uid,
                param: JSON.stringify({
                    ...payload,
                    ticketId: leaveMsg.ticketId
                })
            })
            const res = data
            if (res.retCode === '000000') {
                yield put({
                    type: 'update',
                    payload: {
                        isEvalution: 1,
                        remark: res.item.remark,
                        score: res.item.score
                    }
                })
            }
            callback(res)
        },

        *commitReplyService({ payload, callback }, { call, put, select }) {
            const { uid, sysNum } = window.urlObject
            const { leaveMsg } = yield select()
            // saveUserReplyInfo

            // let pData = payload;
            // pData.replyContent = strEscape(pData.replyContent)

            const data = yield call(saveUserReplyInfo, {
                uid,
                method: 'post',
                param: JSON.stringify({
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    deployId: window?.urlObject?.deployId,
                    ...payload
                }),
                url: 'ws-service/saveUserReplyInfo/4'
            })
            const res = data
            const params = {
                uid,
                param: {
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    showType: 4
                }
            }
            callback(res, params)
        },
        *sendVerifyCode({ payload }, { call, put, select }) {
            const {
                ids: { uid, companyId },
                deployConfigInfo: {
                    item: { language }
                },
                queryParams
            } = yield select((state) => state.app)
            const res = yield call(invokeOtherByUser, {
                uid,
                url: '/ws-service/sendVerificationCode/4',
                method: 'get',
                param: JSON.stringify({
                    ...payload,
                    visitorId: uid,
                    companyId,
                    language,
                    deployId: queryParams?.deployId
                })
            })
            return res
        },
        *checkVerifyCode({ payload }, { call, put, select }) {
            const {
                ids: { uid, companyId },
                deployConfigInfo: {
                    item: { ticketScopeFlag }
                }
            } = yield select((state) => state.app)
            const res = yield call(invokeOtherByUser, {
                uid,
                url: '/ws-service/checkVerificationCode/4',
                method: 'get',
                param: JSON.stringify({
                    ...payload,
                    visitorId: uid,
                    companyId,
                    ticketScopeFlag
                })
            })
            return res
        },
        *sendSmsCode({ payload }, { call, put, select }) {
            const {
                ids: { uid, companyId }
            } = yield select((state) => state.app)
            const res = yield call(sendVerificationCodeBySms, {
                companyId,
                visitorId: uid,
                deployId: window?.urlObject?.deployId || '',
                tel: payload?.tel
            })
            return res
        },
        *checkTicketValidateStatus({ payload }, { call, put, select }) {
            const {
                ids: { uid, companyId },
                deployConfigInfo
            } = yield select((state) => state.app)
            const res = yield call(checkTicketValidateStatus, {
                companyId,
                deployId: window?.urlObject?.deployId || ''
            })
            const data = res?.item || {}
            let isShowPhoneVer = false

            if (data?.tplType === '2' && data?.marketSmsStatus === '2') {
                // 营销类短信
                isShowPhoneVer = true
            }

            if (data?.tplType === '1' && data?.notifiationSmsStatus === '2') {
                // 通知短信
                isShowPhoneVer = true
            }

            return isShowPhoneVer
        },
        *checkSmsVerificationCode({ payload }, { call, put, select }) {
            const {
                ids: { uid, companyId }
            } = yield select((state) => state.app)
            const res = yield call(checkSmsVerificationCode, {
                companyId,
                visitorId: uid,
                tel: payload?.tel,
                verificationCode: payload?.verificationCode
            })
            return res
        },
        *getTicketStatusInfoList({ payload }, { call, put, select }) {
            const { uid, sysNum } = window.urlObject
            const res = yield call(getTicketStatusInfoList, {
                ...payload,
                sysNum,
                flag: 1
            })
            if (res?.retCode === '000000') {
                yield put({
                    type: 'update',
                    payload: {
                        ticketStatusMap: res.items || []
                    }
                })
            }
            // const res = yield call(getTicketStatusInfoList, { flag: 1 })
        }
    }
}
